module.exports = __webpack_public_path__ + "img/Card Back.9a23ace1.png";